/*
Author:      Zachary Thomas
Created:     5/14/2021
Modified:    2/14/2022

Copyright 2021-2022 © Cornell Pump Company, All Rights Reserved
-----------------------------------------------------------------
*/

import React from "react";
import Card from "../../components/Card/Card";
import TextBlurb from "../../components/TextBlurb/TextBlurb";
import "./Error404Page.css";

// Page for displaying 404 errors.
export default function Error404Page() {

  return (
    <div className="page-404 pt-5 mb-4">
      <Card title="Page Not Found" >
        <div className="my-5">
          <TextBlurb
            title="404"
            paragraph="Sorry! The page you are looking for was not found."
            icon="exclamation-triangle"
          />
        </div>
      </Card>
    </div>
  );
}

